import { RaisedButton } from 'material-ui';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import PersonIcon from 'material-ui/svg-icons/social/person';
import TextField from 'material-ui/TextField';
import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import AuthService from './../../../../services/AuthService';

class ListeDesSalaries extends React.Component {

    iconButtonElement = (<IconButton
        touch={true}
        tooltip="Plus"
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon />
    </IconButton>);

    constructor(props) {
        super(props);
        this.state = {
            filterText: ''
        };
        this.Auth = new AuthService();
        this.handleFilterSalaries = this.handleFilterSalaries.bind(this);
    }

    handleFilterSalaries(e, v) {
        this.setState({ filterText: v });
    }


    render() {
        let salaries = [];
        let keyword = this.state.filterText.toUpperCase().trim();
        let filteredSalaries = this.props.liste_des_salaries.filter(s =>
            s.nom.toUpperCase().indexOf(keyword) !== -1
            || s.prenom.toUpperCase().indexOf(keyword) !== -1
            || s.num_salarie.toUpperCase().indexOf(keyword) !== -1);

        for (let i = 0; i < filteredSalaries.length; i++) {
            let s = filteredSalaries[i];

            salaries.push(
                <tr key={i} >

                    <td><PersonIcon /></td>
                    <td>{s.nom + " " + s.prenom}<br />{'N° ' + s.num_salarie}</td>
                    <td></td>
                    <td>
                        <Link style={{ color: 'inherit' }} to={'/entreprise/modifier_un_salarie/' + s.id}>
                            <RaisedButton label="Editer" primary={true} />
                        </Link>
                    </td>
                </tr>)
        }
        return (
            <div>
                <TextField
                    value={this.state.filterText}
                    onChange={this.handleFilterSalaries}
                    name='filterText'
                    type="text"
                    floatingLabelText="Filtrer par nom, prénom ..."
                /><br />
                <table class="table table-hover">
                    <tbody>
                        {salaries}
                    </tbody>
                </table>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return { liste_des_salaries: store.entreprise.entreprise_infos.salaries }
}

export default connect(mapStateToProps)(ListeDesSalaries);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/ListeDesSalaries.js